export const customReportsUrl = {
  executeQuery: "/reports/execute-query",
  getQueriesList: "/reports/get-queries",
};
